import { styled } from "goober";
import { Button } from "./Button";

export const SubtleButton = styled(Button)`
  &.secondary {
    color: var(--text-secondary);
  }
`;
